import request, { download } from "@/utils/request";

// 查询需求列表
export async function demandQuery(params = {}) {
  return await request({
    url: `/newschool/demand/query`,
    method: "get",
    params,
  });
}

// 置顶需求
export async function demandPinTop(data = {}) {
  return await request({
    url: `/newschool/demand/pinTop`,
    method: "put",
    data,
  });
}

// 初始化需求
export async function demandInit(data = {}) {
  return await request({
    url: `/newschool/demand/init`,
    method: "put",
    data,
  });
}

// 更新需求
export async function demandUpdate(data = {}) {
  return await request({
    url: `/newschool/demand/update`,
    method: "put",
    data,
  });
}

// 删除需求
export async function demandDelete(data = {}) {
  return await request({
    url: `/newschool/demand/delete`,
    method: "delete",
    data,
  });
}

// 创建需求
export async function demandCreate(data = {}) {
  return await request({
    url: `/newschool/demand/create`,
    method: "post",
    data,
  });
}

// 查询班级信息
export async function demandClassConfigQuery(params = {}) {
  return await request({
    url: `/newschool/demand-class-config/query`,
    method: "get",
    params,
  });
}

// 课堂互动开关
export async function demandClassConfig(data = {}) {
  return await request({
    url: `/newschool/demand-class-config/config`,
    method: "post",
    data,
  });
}

// 查询参与人数问题数量投票人数
export async function demandSummary(params = {}) {
  return await request({
    url: `/newschool/demand/summary`,
    method: "get",
    params,
  });
}

// 移动需求排序
export async function demandMoveSort(data = {}) {
  return await request({
    url: `/newschool/demand/move-sort`,
    method: "put",
    data,
  });
}

// 查询需求收藏列表
export async function demandCollectionQuery(params = {}) {
  return await request({
    url: `/newschool/demand-collection/query`,
    method: "get",
    params,
  });
}

// 需求问题详情
export async function demandCollectionDetail(params = {}) {
  return await request({
    url: `/newschool/demand-collection/detail`,
    method: "get",
    params,
  });
}

// 需求问题回复
export async function demandReplySonCreate(data = {}) {
  return await request({
    url: `/newschool/demand-reply-son/create`,
    method: "post",
    data,
  });
}
